/* @ngInject */
function TaskTagsController ($scope, $state, $translate, UdsModalService, TaskTagsService, ConfirmationModalService, ToastService) {
  const getCreateTaskTagController = () => import('../../dialogs/create-task-tag/create-task-tag.controller')

  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.tagsTotal = 0
  $scope.loading = false
  $scope.top = 10
  $scope.skip = 0
  $scope.isAsc = false
  $scope.order = 'DESC'
  $scope.sort = 'createdAt'
  $scope.tags = []
  $scope.pageTitle = ''

  const api = {
    _getTags,
    _deleteTag
  }

  this.getApi = () => api

  function activate () {
    $scope.loading = true
    $scope.isAsc = false
    api._getTags({ skip: $scope.skip, top: $scope.top, order: $scope.order, sort: $scope.sort })
  }

  activate()

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('tags')
  })

  function _getTags (queryParams) {
    queryParams.taskCount = true
    TaskTagsService.getTaskTags(queryParams).then((response) => {
      $scope.tags = response.rows
      $scope.tagsTotal = response.count
      $scope.loading = false
    })
  }

  function _deleteTag (tag) {
    return TaskTagsService.deleteTaskTag(tag.id).then(() => {
      ToastService.showSuccessToast($translate.instant('deleteTaskTag.success', { tagName: tag.label }))
      api._getTags({
        search: $scope.searchedName,
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    }).catch(() => {
      ToastService.showErrorToast($translate.instant('deleteTaskTag.error', { tagName: tag.label }))
    })
  }

  $scope.deleteTag = function (tag) {
    ConfirmationModalService.createModal({
      title: $translate.instant('deleteTaskTag.title'),
      description: $translate.instant('deleteTaskTag.description', { tagName: tag.label }),
      buttonConfirmText: $translate.instant('deleteTaskTag.button'),
      buttonCancelText: $translate.instant('cancel'),
      onConfirm: () => {
        api._deleteTag(tag)
      }
    })
  }

  $scope.toggle = function (flag) {
    $scope.sort = flag
    $scope.isAsc = !$scope.isAsc

    if (!$scope.isAsc) {
      $scope.order = 'ASC'
      api._getTags({
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    } else {
      $scope.order = 'DESC'
      api._getTags({
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    }
  }

  $scope.getPaginationPage = function (ev) {
    $scope.skip = (ev.detail.currentPage - 1) * $scope.top
    api._getTags({
      search: $scope.searchedName,
      order: $scope.order,
      skip: $scope.skip,
      top: $scope.top,
      sort: $scope.sort
    })
  }

  $scope.tagsSearch = (term) => {
    $scope.searchedName = term
    if ($scope.searchedName) {
      $scope.skip = 0
    }
    api._getTags({
      search: $scope.searchedName,
      sort: $scope.sort,
      order: $scope.order,
      skip: $scope.skip,
      top: $scope.top
    })
  }

  $scope.openCreateTagModal = function (data) {
    const createTagData = {
      flag: data.flag,
      tagId: data.tagId,
      name: data.name
    }
    getCreateTaskTagController().then(({ CreateTaskTagController }) => {
      const createTag = UdsModalService.createModal({
        controller: CreateTaskTagController,
        modalName: 'createTaskTag',
        data: createTagData,
        onClose: (returnData) => {
          if (returnData?.success) {
            api._getTags({
              search: $scope.searchedName,
              sort: $scope.sort,
              order: $scope.order,
              skip: $scope.skip,
              top: $scope.top
            })
          }
        },
        onOpen: () => {}
      })

      createTag.open()
    })
  }

  $scope.headerNavigation = {
    buttons: [{
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('newTag'),
      icon: 'plus',
      onClick: $scope.openCreateTagModal.bind(null, { flag: 'create' })
    }]
  }

  $scope.headerToolbar = {
    search: {
      onSearch: $scope.tagsSearch
    }
  }
}

export { TaskTagsController }
